module.exports = __webpack_public_path__ + "static/media/achievement_star.bef3a62a.svg";